import { EventData } from '../../models'
import { eventFormatter } from '../../utils/eventFormatter'
import AbstractProvider from '../AbstractProvider'

export default class SegmentProvider implements AbstractProvider {
  public identify(userId: string, traits?: object): void {
    this.identifyUser(userId, traits)
  }

  public log(eventName: string, eventData: EventData): void {
    const logData = eventFormatter(eventData)

    this.track(eventName, logData)
  }

  /**
   * To identify user request by session
   * @param id
   */
  private identifyUser(id: string, traits?: object): void {
    analytics.identify(id, traits)
  }

  /**
   * Add custom data to idenfity user
   * @param traits
   */
  public identifyTraits(traits: object): void {
    analytics.identify(traits)
  }

  /**
   * Tracking event
   * @param action
   * @param data
   */
  private track(action: string, data: object): void {
    analytics.track(action, data)
  }
}
